import { messagesApi } from '@/utils/api'

const state = {
  unreadCount: 0,
  messages: [],
  showMessageCenter: false
}

const getters = {
  unreadCount: s => s.unreadCount,
  showMessageCenter: s => s.showMessageCenter
}

const mutations = {
  SET_UNREAD_COUNT(state, count) { state.unreadCount = count },
  SET_MESSAGES(state, list) { state.messages = list },
  SET_SHOW_MESSAGE_CENTER(state, val) { state.showMessageCenter = val },
  MARK_READ_LOCAL(state, ids) {
    state.messages.forEach(m => { if (ids.includes(m.id)) m.is_read = 1 })
    state.unreadCount = state.messages.filter(m => !m.is_read).length
  },
  MARK_ALL_READ_LOCAL(state) {
    state.messages.forEach(m => { m.is_read = 1 })
    state.unreadCount = 0
  },
  REMOVE_MESSAGES_LOCAL(state, ids) {
    state.messages = state.messages.filter(m => !ids.includes(m.id))
    state.unreadCount = state.messages.filter(m => !m.is_read).length
  }
}

const actions = {
  async fetchUnreadCount({ commit }) {
    try {
      const data = await messagesApi.getUnreadCount()
      commit('SET_UNREAD_COUNT', data.count || 0)
    } catch (e) { /* 静默失败 */ }
  },

  async fetchMessages({ commit }, params = {}) {
    try {
      const data = await messagesApi.getList(params)
      commit('SET_MESSAGES', data || [])
    } catch (e) { /* 静默失败 */ }
  },

  async markRead({ commit }, ids) {
    commit('MARK_READ_LOCAL', ids)
    try { await messagesApi.markRead({ ids }) } catch (e) { /* 静默失败 */ }
  },

  async markAllRead({ commit }) {
    commit('MARK_ALL_READ_LOCAL')
    try { await messagesApi.markRead({ all: true }) } catch (e) { /* 静默失败 */ }
  },

  async deleteMessages({ commit }, ids) {
    commit('REMOVE_MESSAGES_LOCAL', ids)
    try { await messagesApi.deleteMessages({ ids }) } catch (e) { /* 静默失败 */ }
  },

  openMessageCenter({ commit, dispatch }) {
    commit('SET_SHOW_MESSAGE_CENTER', true)
    dispatch('fetchMessages')
  },

  closeMessageCenter({ commit }) {
    commit('SET_SHOW_MESSAGE_CENTER', false)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
